<script>
import { authComputed, navComputed } from '@state/helpers'

export default {
  data() {
    return {
      menu: false,
    }
  },
  computed: {
    ...authComputed,
    ...navComputed,
    openRightSideDrawer() {
      return this.calendarDrawer || this.settingsDrawer
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.menu = true
    })
  },
  methods: {
    updateMenu(value) {
      this.$emit('menu-updated', value)
    },
  },
}
</script>

<template>
  <v-menu
    v-model="menu"
    rounded="lg"
    offset-y
    left
    top
    nudge-top="15"
    nudge-left="10"
    :close-on-content-click="false"
    transition="slide-y-reverse-transition"
  >
    <template v-slot:activator="{ on }">
      <!-- activator slot -->
      <div
        :class="
          openRightSideDrawer
            ? $style.avatarContainerOffset
            : $style.avatarContainer
        "
      >
        <v-avatar :class="$style.appBarAvatar" size="45" v-on="on">
          <v-img
            contain
            :src="require('@assets/images/doctor_avatar_cropped.png')"
          ></v-img>
        </v-avatar>
      </div>
    </template>
    <v-card height="255" width="215">
      <v-card-text :class="$style.avatarRow">
        <v-container class="fill-height" fluid>
          <v-row
            :class="$style.greetingsText"
            :title="serializedUser.first_name"
            class="primary--text truncate"
            no-gutters
            >Hi {{ serializedUser.first_name }}!</v-row
          >
          <v-row :class="$style.questionText" class="body--text" no-gutters
            >How’s it going today?</v-row
          >
          <v-row justify="center">
            <v-btn
              dark
              class="text-capitalize"
              elevation="0"
              outlined
              color="primary"
              :class="$style.recordBtn"
              height="40"
              width="166"
              @click="
                $emit('add-hr')
                menu = false
              "
            >
              <div :class="$style.btnText"> Add new record </div>
            </v-btn>
          </v-row>
          <v-row justify="center">
            <v-btn
              dark
              class="text-capitalize"
              elevation="0"
              :class="$style.symptomBtn"
              width="166"
              height="40"
              @click="
                $emit('add-sc')
                menu = false
              "
            >
              <div :class="$style.btnText"> Check Symptoms </div>
            </v-btn></v-row
          >
        </v-container>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<style lang="scss" module>
@import '@design';

.avatarRow {
  height: 100%;
}

.appBarAvatar {
  padding: 5px;
  cursor: pointer;
  background: $color-theme-light-bg;
}

.avatarContainer {
  position: fixed;
  right: 44px;
  bottom: 44px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 51px;
  height: 51px;
  background: linear-gradient(95.08deg, #00baff 2.49%, #063ef9 97.19%);
  border-radius: 50%;
}

.avatarContainerOffset {
  position: fixed;
  right: 44px;
  bottom: 44px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 51px;
  height: 51px;
  background: linear-gradient(95.08deg, #00baff 2.49%, #063ef9 97.19%);
  border-radius: 50%;
  transform: translateX(-300px);
}

.greetingsText {
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.75px;
}

.questionText {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.75px;
}

.symptomBtn {
  background: rgb(15, 94, 249);
  background: linear-gradient(95.08deg, #00baff 2.49%, #063ef9 97.19%);
  border-radius: 8px;
}

.recordBtn {
  border: 2px solid;
  border-radius: 8px;
}

.recordBtn .btnText {
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.25px;
}

.symptomBtn .btnText {
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.25px;
}
</style>
